import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import axios from "axios";
import SuccessMessage from "../components/SuccessMessage";
import { useNavigate } from "react-router-dom";
// import { MdDeleteForever } from "react-icons/md";
import { FaArrowRightLong } from "react-icons/fa6";
// import { FaEdit } from "react-icons/fa";
import AddAddress from "../components/AddAddress";
// import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Address() {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const { isLoggedIn, userInfo, loading } = useAuth();

    const [cartItems, setCartItems] = useState([]);
    const [orderSuccess, setOrderSuccess] = useState(false);
    const customerType = localStorage.getItem("CustomerType");
    const ledcode = localStorage.getItem("Ledcode");
    const LedName = localStorage.getItem("LedName");
    const navigate = useNavigate();

    // const location = useLocation();

    useEffect(() => {
        if (loading || !isLoggedIn) return;

        const fetchCartData = async () => {
            try {
                const ledcode = userInfo?.Ledcode;
                if (!ledcode) {
                    console.warn("Ledcode not found");
                    return;
                }

                const res = await axios.get(`${apiBaseUrl}/cart/items/JAPAN_ACCESORIES/${ledcode}`);
                if (res.data?.success && Array.isArray(res.data.items)) {
                    const serverCartItems = res.data.items.map((item) => ({
                        itemName: item.itemName,
                        id: item.itemId,
                        mop: item.itemPrice,
                        dp: item.itemPrice,
                        mrp: item.itemPrice,
                        quantity: item.quantity,
                        uniqueCode: item.uniqueCode || "0",
                        selectedModel: item.selectedModel || "",
                        branch: item.branch || "",
                        realpratetax: item.realpratetax || 0,
                    }));
                    setCartItems(serverCartItems);
                }
            } catch (error) {
                console.error("Error fetching cart from API:", error);
            }
        };

        fetchCartData();
    }, [loading, isLoggedIn, userInfo, apiBaseUrl]);

    const getPriceBasedOnCustomerType = (item) => {
        switch (customerType) {
            case "CUSTOMER":
                return item.mop;
            case "DEALER":
                return item.dp;
            case "AGENT":
                return item.ap;
            case "JS_MANAGER":
                return item.mop;
            case "JS_EMPLOYEE":
                return item.mop;
            case "TK_MANAGER":
                return item.mop;
            case "TK_EMPLOYEE":
                return item.mop;
            default:
                return item.mrp; // Default if customerType is unknown
        }
    };

    const [addressList, setAddressList] = useState([]);

    const fetchAddresses = async () => {
        const ledcode = localStorage.getItem("Ledcode");
        if (!ledcode) return;

        try {
            const response = await fetch(`${apiBaseUrl}/user/getAddresses/${ledcode}/JAPAN_ACCESORIES`);
            const result = await response.json();
            const addresses = Array.isArray(result) ? result : Array.isArray(result.data) ? result.data : [];
            setAddressList(addresses);

            if (addresses.length > 0) {
                const active = addresses.find((addr) => addr.isActive);
                setSelectedAddressId(active ? active.id : addresses[0].id);
            }
        } catch (err) {
            console.error("Error fetching address list:", err);
            setAddressList([]);
        }
    };

    const [selectedAddressId, setSelectedAddressId] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [editedAddress, setEditedAddress] = useState({});

    const [showForm, setShowForm] = useState(false);
    const [addresses, setAddresses] = useState([]);

    const handleAddAddress = (newAddress) => {
        setAddresses([...addresses, newAddress]);
    };

    const setActiveAddress = async (addressId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/user/setActiveAddress/JAPAN_ACCESORIES`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ addressId, ledcode }),
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result.message || "Failed to set active address.");
            return result;
        } catch (error) {
            console.error("Error setting active address:", error);
            throw error;
        }
    };

    const handleSelect = async (id) => {
        try {
            await setActiveAddress(id); // Set on server
            setSelectedAddressId(id); // Update UI
            setEditedAddress({});
        } catch (err) {
            alert("Failed to set active address.");
        }
    };

    useEffect(() => {
        fetchAddresses();
    }, [apiBaseUrl]);

    const selectedAddress = addressList.find((addr) => addr.id === selectedAddressId);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedAddress((prev) => ({ ...prev, [name]: value }));
    };

    const total = cartItems
        .reduce((total, item) => total + parseFloat(getPriceBasedOnCustomerType(item)) * parseFloat(item.quantity), 0)
        .toFixed(2);

    const handleSubmit = async () => {
        if (ledcode === "0") {
            alert("Please login first.");
            return;
        }

        if (!cartItems || cartItems.length === 0) {
            alert("Cart is empty");
            return;
        }

        if (!selectedAddressId) {
            alert("Please select a delivery address.");
            return;
        }

        const currentDate = new Date().toISOString().split("T")[0];
        const cDate = new Date().toLocaleDateString("en-GB");
        const mobile = "";

        const itemsArray = cartItems.map((item) => {
            const customerTypeKey = customerType?.toUpperCase();
            let dp = item.dp;

            if (customerTypeKey === "CUSTOMER") dp = item.mop;
            else if (customerTypeKey === "AGENT") dp = item.ap;
            else if (customerTypeKey === "JS_EMPLOYEE" || customerTypeKey === "TK_EMPLOYEE") dp = item.branch;
            else if (customerTypeKey === "JS_MANAGER" || customerTypeKey === "TK_MANAGER") dp = item.realPrateTax;

            const quantity = parseInt(item.quantity || 1);
            const mrp = parseFloat((item.mrp || dp) * quantity).toFixed(2);

            return {
                id: item.id,
                name: item.itemName,
                model: item.selectedModel || "",
                dp: parseFloat(dp),
                mrp: parseFloat(mrp),
                quantity,
            };
        });

        const order = {
            date: currentDate,
            id: ledcode,
            contact: mobile,
            items: JSON.stringify(itemsArray),
        };

        console.log("Final order:", order);

        try {
            const response = await axios.post(`${apiBaseUrl}/orderAdd/JAPAN_ACCESORIES`, order, {
                headers: {
                    "Content-Type": "application/json",
                },
                validateStatus: () => true, // Accept all statuses
            });

            console.log("Response received:", response);

            const isSuccess =
                typeof response.data === "object" &&
                response.data !== null &&
                response.data.message?.toLowerCase() === "success";

            if (response.status === 200 && isSuccess) {
                setOrderSuccess(true);

                // Clear cart
                localStorage.removeItem("selectedProducts");
                setCartItems([]);

                // WhatsApp Message
                let tableText = `Date: ${cDate}\nCustomer Name: ${LedName}\n\nCheckout my cart items:\n\n`;
                const message = itemsArray
                    .map(
                        (item) =>
                            `Product: ${item.name}\nModel: ${item.model}\nPrice: ₹${item.dp.toFixed(2)}\nQuantity: ${
                                item.quantity
                            }`
                    )
                    .join("\n\n");

                const total = itemsArray.reduce((acc, item) => acc + item.mrp, 0);
                tableText += message;
                tableText += `\n\nTotal Amount: ₹${total.toFixed(2)}`;

                const encodedMessage = encodeURIComponent(tableText);

                // Delay redirect slightly to allow cart clearing
                setTimeout(() => {
                    window.location.href = `whatsapp://send?text=${encodedMessage}`;
                    navigate("/cart", { state: { addedSum: total } });
                }, 10000);
            } else {
                console.warn("Unexpected response structure:", response.data);
                throw new Error("Unexpected server response");
            }
        } catch (error) {
            console.error("Order submission failed:", error.response?.data || error.message || error);
            alert("Failed to submit order. Please try again.");
        }
    };

    return (
        <div className="min-h-screen flex flex-col  flex-1 pb-5">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>

            <div className="w-full lg:px-[7%] px-[2%] flex flex-col fixed md:mt-28 mt-14 pb-3 bg-[white]">
                <div className="flex flex-row lg:w-[68%] justify-between items-center pt-4">
                    <div>
                        <span className="font-[600] w-full flex  md:text-xl text-[#BB002D] font-display ">
                            Select Delivery Address
                        </span>
                    </div>

                    <div className="">
                        <button
                            type=""
                            onClick={() => setShowForm(true)}
                            className=" items-center font-medium border-2 text-[#BB002D] rounded text-sm px-3 py-1"
                        >
                            <span>Add New Address</span>
                        </button>
                    </div>
                </div>
                <div>
                    <div className="absolute z-10 w-[96%] lg:w-[54%] lg:m-10">
                        {showForm && <AddAddress onAdd={handleAddAddress} onCancel={() => setShowForm(false)} />}
                    </div>
                </div>
            </div>
            <div className="w-full lg:px-[7%] px-[2%] flex flex-col  mt-10">
                <div className="w-full flex lg:flex-row flex-col gap-8 mt-8">
                    <div className="lg:w-[70%] flex flex-col gap-4 mb-10">
                        {addressList.map((item, index) => (
                            <div
                                key={item.id}
                                className={`w-full border-2 ${
                                    selectedAddressId === item.id ? "border-[#8e8e90]" : "border-[#EAEAEC]"
                                }  rounded-md p-4`}
                            >
                                {/* Header with radio and name */}
                                {/* <div className="flex items-center justify-between mb-2">
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            name="selectedAddress"
                                            checked={selectedAddressId === item.id}
                                            onChange={() => handleSelect(item.id)}
                                            className="accent-[#8B0000] w-4 h-4"
                                        />
                                        <p className="font-bold text-lg  text-[#444]">{item.name}</p>
                                        <p className="border-2 font-semibold text-sm rounded-full px-3 text-[#444]">
                                            {item.addressType}
                                        </p>
                                    </div>
                                </div> */}

                                {/* Address content */}
                                {/* <div className="text-sm text-[#333] ml-7">
                                    {editIndex === index ? (
                                        <>
                                            <input
                                                className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                                                name="mobile"
                                                value={editedAddress.mobile}
                                                onChange={handleChange}
                                            />
                                            <select
                                                name="addressType"
                                                value={editedAddress.addressType}
                                                onChange={handleChange}
                                                className="w-full mb-2 border border-[#b8b8b9] p-1 rounded"
                                            >
                                                <option value="Home">Home</option>
                                                <option value="Office">Office</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </>
                                    ) : (
                                        <>
                                            <div>
                                                <p className="font-medium mb-1">
                                                    {[item.address].filter(Boolean).join(", ")}
                                                </p>
                                                <p className="font-medium mb-1">
                                                    {[item.locality, item.city].filter(Boolean).join(", ")}
                                                </p>
                                                <p className="font-medium mb-1">
                                                    {[item.district, item.pincode].filter(Boolean).join(", ")}
                                                </p>
                                            </div>

                                            <div className="flex">
                                                <p className="text-[#878787] font-medium">Mobile number:&nbsp;</p>
                                                <p className="font-medium">{item.mobile}</p>
                                            </div>
                                        </>
                                    )}
                                </div> */}

                                <label
                                    htmlFor={`address-${item.id}`}
                                    className={`cursor-pointer ${
                                        selectedAddressId === item.id ? "border-[#cececf]" : "border-[#EAEAEC]"
                                    } rounded-md p-4 block`}
                                >
                                    {/* ✅ Flex container for radio and details */}
                                    <div className="flex items-start gap-4">
                                        {/* Radio Button */}
                                        <input
                                            type="radio"
                                            id={`address-${item.id}`}
                                            name="selectedAddress"
                                            checked={selectedAddressId === item.id}
                                            onChange={() => handleSelect(item.id)}
                                            className="mt-1 w-5 h-5 accent-[#BB002D]" // Adjust size/style if needed
                                        />

                                        {/* Address Details */}
                                        <div className="flex-1">
                                            {/* Address Header */}
                                            <div className="flex items-center gap-2 mb-2">
                                                <p className="font-bold text-lg text-[#444]">{item.name}</p>
                                                <p className="border-2 font-semibold text-sm rounded-full px-3 text-[#444]">
                                                    {item.addressType}
                                                </p>
                                            </div>

                                            {/* Address Text */}
                                            <div className="text-sm text-[#333]">
                                                <p className="font-medium mb-1">
                                                    {[
                                                        item.address,
                                                        item.locality,
                                                        item.city,
                                                        item.district,
                                                        item.state,
                                                        item.pincode,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(", ")}
                                                </p>
                                                <div className="flex">
                                                    <p className="text-[#878787] font-medium">Mobile number:&nbsp;</p>
                                                    <p className="font-medium">{item.mobile}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        ))}
                    </div>

                    <div className="w-full lg:w-[30%]">
                        <div className="w-full lg:w-[100%] flex flex-col lg:mb-0 sticky top-40">
                            <div className="border-2 rounded-md border-[#EAEAEC] pb-4 bg-white shadow-md">
                                <div className="w-full h-[18%] bg-[#FFF6F4] px-3 py-3 flex justify-between items-center text-base font-[600] font-[display]">
                                    <span className="text-base font-[600] font-display">Price Details</span>
                                </div>

                                <div className="w-full h-[82%]   flex  flex-col px-3 gap-2">
                                    <ul className=" mt-5" />
                                    <div className="flex flex-col gap-5 w-full">
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">
                                                Sub Total ({cartItems.length})
                                            </span>
                                            <span className="text-base font-[600] font-display">₹{total}</span>
                                        </div>
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">Shipping</span>
                                            <span className="text-base font-[600] font-display">₹00.00</span>
                                        </div>
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">Discount</span>
                                            <span className="text-base font-[600] font-display">₹00.00</span>
                                        </div>
                                        <div className="w-full flex justify-between">
                                            <span className="text-base text-[#959596] font-display">Tax</span>
                                            <span className="text-base font-[600] font-display">₹00.00</span>
                                        </div>
                                    </div>
                                    <ul className="border-2 border-black mt-5 text-[#F0F0F0]" />
                                    <div className="w-full flex justify-between">
                                        <span className="text-base font-[600] font-display">Total Amount</span>
                                        <span className="text-base font-[600] font-display">
                                            ₹
                                            {cartItems
                                                .reduce(
                                                    (total, item) =>
                                                        total +
                                                        parseFloat(getPriceBasedOnCustomerType(item)) *
                                                            parseFloat(item.quantity),
                                                    0
                                                )
                                                .toFixed(2)}
                                        </span>
                                    </div>
                                    {/* <ul className="border-b-2 border-black border-dashed " /> */}
                                </div>
                            </div>

                            <div className="p-4 mt-9 rounded-md bg-[#EAEAEC]">
                                <button
                                    className="h-[50px] w-full bg-[#BB002D] rounded-[5px] flex justify-center items-center text-base font-[500] font-display text-[white] cursor-pointer"
                                    onClick={handleSubmit}
                                >
                                    PROCEED TO CHECKOUT
                                    <FaArrowRightLong className="ml-2" />
                                </button>
                            </div>
                        </div>
                        {/* <div className=" h-[80px] bg-[#FFF6F4] justify-center lg:hidden flex items-center  fixed bottom-0 w-full">
                            <div
                                className="h-[50px] w-[80%] bg-[#BB002D] rounded-[5px] flex justify-center items-center text-base font-[500] font-display text-[white] cursor-pointer"
                                onClick={handleSubmit}
                            >
                                PROCEED TO CHECKOUT
                                <FaArrowRightLong />
                            </div>
                        </div> */}
                    </div>
                </div>
                {orderSuccess ? (
                    <div className="p-4 bg-[#dcfce7] text-[#166534] rounded shadow text-center mb-4">
                        <SuccessMessage />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
}

export default Address;
